import { DynamicFormTypes } from '../DynamicFormTypes';

export const getClassNameForButton = (
  step: number,
  childrenArray: React.ReactElement<
    DynamicFormTypes.FormikStepProps,
    string | React.JSXElementConstructor<any>
  >[],
  gatsbyPathName: string
) => {
  if (
    step === childrenArray.length - 2 ||
    (step === childrenArray.length - 1 && gatsbyPathName.includes('reserve'))
  ) {
    return 'is-justify-content-end';
  } else {
    return 'is-justify-content-end';
  }
};
